export const environment = {
  version: "1.1",
  production: true,
  domain: "",
  inactivity: 10,
  showLotsPDC: false,

  sentryDsn: "https://b22c05730721062895810ef634437bc8@sentry.admin-op.ovh/3",
  sentryEnable: true,

  api() {
    return `${this.domain}/api`;
  },

  chatApi() {
    return `${this.domain}/chatApi`;
  },

  aristoteApi() {
    return `${this.domain}/device/api`;
  },

  docApi() {
    return `${this.domain}/doc/api/v1`;
  },

  pdfApi() {
    return `${this.domain}/pdf/api`;
  },

  mailApi() {
    return `${this.domain}/mail/api`;
  },

  adminApi() {
    const port = parseInt(window.location.port, 10);
    // Realm workspace: port 8x80 → admin on port 8x81 (same host)
    if (port && port >= 8080 && port % 100 === 80) {
      return `${window.location.protocol}//${window.location.hostname}:${port + 1}/api/v1`;
    }
    // Production: admin.{domain}/api/v1
    const hostname = window.location.hostname;
    const parts = hostname.split(".").filter(Boolean);
    const base = parts.slice(-2).join(".");
    return `https://admin.${base}/api/v1`;
  },
};
